import { render, staticRenderFns } from "./SessionEditDialog.vue?vue&type=template&id=23bc63fe&scoped=true"
import script from "./SessionEditDialog.vue?vue&type=script&lang=js"
export * from "./SessionEditDialog.vue?vue&type=script&lang=js"
import style0 from "./SessionEditDialog.vue?vue&type=style&index=0&id=23bc63fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23bc63fe",
  null
  
)

export default component.exports